import {VStack} from 'platform/foundation';

import i18n from '@dms/i18n';
import {SettingsSection, SettingsTemplate} from '@dms/settings/shared';

import {CopyRealCostsToExpectedSwitch} from '../../components/CopyRealCostsToExpectedSwitch/CopyRealCostsToExpectedSwitch';
import {FinancingForm} from './components/FinancingForm';

export function Financing() {
  return (
    <SettingsTemplate
      header={{title: i18n.t('entity.financing.labels.pageTitle')}}
      data-testid="sales-financing"
      description={i18n.t('entity.financing.labels.description')}
    >
      <VStack spacing={6}>
        <FinancingForm />

        <SettingsSection>
          <CopyRealCostsToExpectedSwitch data-testid="sales-financing-copyRealCostsToExpected" />
        </SettingsSection>
      </VStack>
    </SettingsTemplate>
  );
}
